import useApiMutation from '_api/mutations/useApiMutation';

import { PasswordChangePayload } from './types';

export const PASSWORD_CHANGE = 'password-change';

export const usePasswordChange = () => {
  return useApiMutation<{}, PasswordChangePayload>(
    () => `/user/password-change`,
    'post',
    undefined,
    {
      mutationKey: [PASSWORD_CHANGE],
    },
    (body: PasswordChangePayload) => JSON.stringify(body),
  );
};
